import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";
import { SubsidiariesResponse } from "../Subsidiaries/types";
const fetchData = async <T>(url: string): Promise<T> => {
  const response = await corporateCMSApi.get<T>(url);
  return response.data;
};

const createDataHook =
  <T>(key: string, url: string) =>
  (
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key],
        enabled: false,
        queryFn: () => fetchData<T>(url),
        refetchOnWindowFocus: false,
        ...options,
      },

      queryClient
    );
  };

const useSubsidiariesData = createDataHook<SubsidiariesResponse[]>(
  "subsidiaries",
  `/api/page-content/all-fields?pageName=about-us/subsidiaries`
);

export { useSubsidiariesData };
